import { render, staticRenderFns } from "./ProductCategory.vue?vue&type=template&id=83623212"
import script from "./ProductCategory.vue?vue&type=script&lang=js"
export * from "./ProductCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports